import {Typed} from "app/stimulus/typed-stimulus";
import {LiveComponentAwareController} from "app/stimulus/live-component-aware-controller";
import {Controller} from "@hotwired/stimulus";
import {AsStimulusController} from "app/stimulus/as-stimulus-controller";
import {componentsLoader} from "app/service/components-loader";
import {Component} from "@symfony/ux-live-component";

@AsStimulusController('crm-person-detail-bank-accounts')
export default class extends Typed(LiveComponentAwareController(Controller<HTMLElement>))
{
    declare private onComponentRenderFinished: () => void;

    public initialize(): void {
        this.onComponentRenderFinished = this.initJs.bind(this);
    }

    public connect(): void {
        this.initJs();
    }

    public liveComponentConnect(component: Component) {
        component.on('render:finished', this.onComponentRenderFinished);
    }

    public liveComponentDisconnect(component: Component) {
        component.off('render:finished', this.onComponentRenderFinished);
    }

    private initJs(): void {
        componentsLoader.load(this.element);
    }
}
